<template>
  <q-page>
    <div
      v-if="ready && pin && pin.id"
      class="pin-detail container relative-position flex flex-center"
    >
      <div class="row">
        <div class="col col-xs-12 col-md-6 col-lg-7 q-pa-xs">
          <q-card bordered class="q-pa-xs q-mb-md">
            <q-item>
              <q-item-section avatar>
                <q-avatar>
                  <img src="https://cdn.quasar-framework.org/img/avatar2.jpg">
                </q-avatar>
              </q-item-section>

              <q-item-section>
                <q-item-label class="topic">{{pin.topic}}</q-item-label>
                <q-item-label caption class="author">~{{pin.author}}</q-item-label>
              </q-item-section>
            </q-item>
            <q-card-section class="op-media">
              <div class="relative-position container flex flex-center" v-ripple>
                <a :href="pin.image" target="_blank">
                  <img class="op-image" :src="pin.image" alt="pin.topic">
                </a>
              </div>
            </q-card-section>
            <q-card-section class="op-body q-my-xl q-pa-xl">{{pin.body}}</q-card-section>
          </q-card>
        </div>
        <div class="col col-xs-12 col-md-6 col-lg-5 q-pa-xs">
          <q-card class="q-pa-xs full-height">
            <q-card-section>
              <div class="column">
                <q-chat-message
                  v-if="user.exists"
                  :name="user.data.alias"
                  avatar="https://cdn.quasar-framework.org/img/avatar1.jpg"
                  :text="['this is awesome']"
                  stamp="7 minutes ago"
                  sent
                  size="10"
                  bg-color="positive"
                />
                <q-chat-message
                  name="Anonymous"
                  avatar="https://cdn.quasar-framework.org/img/avatar5.jpg"
                  :text="['loooooool so funny XD']"
                  stamp="4 minutes ago"
                  text-color="black"
                  bg-color="grey-3"
                  size="10"
                />
              </div>
            </q-card-section>
          </q-card>
        </div>
      </div>
    </div>
  </q-page>
</template>

<script>
import { dispatch } from '@/state'

export default {
  name: 'PinDetail',
  data() {
    return {
      ready: false,
      pin: {
        topic: '',
        id: '',
      },
      ...this.mapState('pins', 'user'),
    }
  },
  watch: {
    $route: function() {
      const pinId = this.$route.params.pinId
      this.pin = { ...this.pins.library[pinId] }
    },
  },
  async beforeRouteEnter(to, from, next) {
    await dispatch.pins.fetchPin(to.params.pinId)
    next()
    return
  },
  created() {
    const pinId = this.$route.params.pinId
    this.pin = { ...this.pins.library[pinId] }
    this.ready = true
  },
}
</script>

<style lang="scss">
.pin-detail {
  // text-transform: uppercase;
  overflow: auto;
  .topic {
    font-size: 1.5em;
    font-weight: 500;
    @media screen and (max-width: 420px) {
      font-size: 1em;
    }
  }
  .author {
    font-size: 1.1em;
    font-weight: 200;
  }
  .op-image {
    width: 100%;
    text-align: center;
    margin: 0 auto;
    display: block;
  }
  .op-image-container,
  .op-image {
    cursor: pointer;
    border-radius: 5px;
  }
  .op-body {
    font-size: 1.1em;
  }
}
</style>
